module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleBlur),
      expression: "handleBlur"
    }],
    staticClass: "item-select",
    class: {
      'disable': _vm.item.nonEditable === 1
    }
  }, [(!_vm.form[_vm.item.attr].id && (JSON.stringify(_vm.form[_vm.item.attr]) === '{}' || _vm.form[_vm.item.attr].length === 0)) ? _c('el-autocomplete', {
    attrs: {
      "disabled": _vm.multiselect,
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": _vm.multiselect ? '请点击“选择”添加' : '请输入名称搜索或点击“选择”添加'
    },
    on: {
      "select": _vm.selectedChecked
    },
    model: {
      value: (_vm.itemValue),
      callback: function($$v) {
        _vm.itemValue = $$v
      },
      expression: "itemValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.multiselect && _vm.form && _vm.form[_vm.item.attr]) ? _vm._l((_vm.form[_vm.item.attr]), function(formItem, i) {
    return _c('span', {
      key: formItem.id,
      staticClass: "item"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(formItem.value))]), _vm._v(" "), _c('i', {
      staticClass: "del el-icon-close",
      on: {
        "click": function($event) {
          _vm.del(i)
        }
      }
    })])
  }) : _vm._e(), _vm._v(" "), (!_vm.multiselect && _vm.form && _vm.form[_vm.item.attr].id) ? _c('span', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.form[_vm.item.attr].value))]), _vm._v(" "), _c('i', {
    staticClass: "del el-icon-close",
    on: {
      "click": function($event) {
        _vm.del()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "select-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleSelect(_vm.module)
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), (_vm.showAssociated) ? _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('associated-new', {
    ref: "associatedNew",
    attrs: {
      "module": _vm.module,
      "item": _vm.item,
      "fromMoudle": _vm.fromMoudle,
      "customerId": _vm.customerId,
      "attrValue": _vm.formatAttrValue(_vm.form[_vm.item.attr]),
      "multiselect": _vm.multiselect
    },
    on: {
      "close": function($event) {
        _vm.showAssociated = false
      },
      "emitObj": _vm.emitObj,
      "addNew": _vm.addNew
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showAssociated) ? _c('div', {
    staticClass: "detail-bg",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.detailShow = false
      }
    }
  }) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-736cbe27","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/associated-field.vue
// module id = 1299
// module chunks = 82